import { render } from "./Datenschutz.vue?vue&type=template&id=ad8364b0&scoped=true&bindings={}"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"

import "./Datenschutz.vue?vue&type=style&index=0&id=ad8364b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad8364b0"

export default script